const initialState = {
  activeItem: null,
  activeItemIndex: null,
};

const Actions = {
  ACTIVE_ITEM_CHANGED: 'item-details/active-item-changed',
};

const activeItemChanged = ({ item, index }: { item; index? }) => ({
  type: Actions.ACTIVE_ITEM_CHANGED,
  item,
  index,
});

function reducer(state = initialState, action) {
  switch (action.type) {
    case Actions.ACTIVE_ITEM_CHANGED:
      return {
        ...state,
        activeItem: action.item,
        activeItemIndex: action.index,
      };
  }
  return state;
}

function selectActiveItem(state) {
  return state.itemDetails.activeItem;
}

function selectActiveItemIndex(state) {
  return state.itemDetails.activeItemIndex;
}

export { reducer, activeItemChanged, selectActiveItem, selectActiveItemIndex };
